import { mapGetters } from 'vuex'
import i18n from '@/locales'

export default {
  computed: mapGetters(['isAdminMode', 'userInfo']),
  created () {
    this.columns = [
      {
        title: '#ID',
        field: 'id',
        // sortable: true,
      },
      {
        title: 'PS1',
        field: 'ps1',
      },
      {
        title: i18n.t('common.command'),
        field: 'command',
      },
      {
        title: i18n.t('system.text_533'),
        field: 'user',
      },
      {
        title: i18n.t('table.title.obj_type'),
        field: 'obj_type',
        formatter: ({ row }) => {
          const { obj_type } = row
          if (obj_type === 'server') {
            return i18n.t('common_239')
          }
          if (obj_type === 'host') {
            return i18n.t('dictionary.host')
          }
          return '-'
        },
      },
      {
        title: i18n.t('table.title.res_name'),
        field: 'obj_name',
      },
      {
        title: 'IP',
        field: 'notes',
        formatter: ({ row }) => {
          const { notes = '{}' } = row
          const { ip = '-' } = JSON.parse(notes)
          return ip
        },
      },
      {
        title: i18n.t('common.login_user'),
        field: 'login_user',
      },
      {
        field: 'start_time',
        title: i18n.t('common_156'),
        // sortable: true,
        width: 170,
        formatter: ({ row }) => {
          if (row.start_time) {
            return this.$moment(row.start_time).format()
          }
          return '-'
        },
      },
    ]
  },
}
